import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Spin } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { onEnterAvis } from '../../actions';
import AvisDetall from './avisDetall';
import AvisInformacioAddicional from './avisInformacioAddicional';
import AvisSelectorModeObtencioAvisos from './avisSelectorModeObtencioAvisos';
import AvisMapa from './avisMapa';
import AvisLlista from './avisLlista';
import { RETARD_MILISEGONS_APARICIO_SPINNER } from '../../constants';
import seguretatWrapper from '../seguretat/seguretatWrapper';
import { rutaIntroduirAvisos } from '../../routes/routeConstants';
import { esPotCrearAvis } from '../../commons/callbacksSeguretat';
import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';
import selectorAvisPerId from '../../selectors/selector_avis_per_id';

/**
 * Retorna true si no es pot renderitzar el component, en cas contrari retornar false. El component es pot mostrar si te informat
 * els meteors i la data actual.
 * @param {String} dataActual
 * @param {Object} meteors
 */
const noEsPotRenderitzarComponent = (dataActual, meteors) => {
    return (!dataActual || dataActual === ''
        || !meteors || Object.keys(meteors).length === 0);
};

class Avis extends Component {

    componentDidMount() {
        this.props.onEnterAvis();
    }

    render() {
        const { peticioMeteorsEnCurs,
            peticioDataActualEnCurs,
            avisSeleccionat,
            meteors,
            dataActual } = this.props;

        const renderBuit = () => {
            return (<div className='avis'></div>);
        };

        const LinkAmbSeguretat = seguretatWrapper(Link, esPotCrearAvis);

        const renderAvisVisualitzacio = () => {
            return (
                <div className='avis'>
                    <div className='avis-boto-inserir'>
                        <LinkAmbSeguretat to={rutaIntroduirAvisos}>
                            <Button type='primary' icon='plus-circle-o'>
                                Avís
                            </Button>
                        </LinkAmbSeguretat>
                    </div>

                    <AvisSelectorModeObtencioAvisos />

                    <AvisLlista />

                    <AvisMapa />

                    <div className="avis-detall-informacio-addicional">
                        { (avisSeleccionat) ? <AvisDetall avis={avisSeleccionat}/> : <AvisInformacioAddicional /> }
                    </div>
                </div>
            );
        };

        return (
            <Spin spinning={peticioMeteorsEnCurs || peticioDataActualEnCurs} delay={RETARD_MILISEGONS_APARICIO_SPINNER}>
                {noEsPotRenderitzarComponent(dataActual, meteors) ? renderBuit() : renderAvisVisualitzacio()}
            </Spin>
        );
    }
}

Avis.propTypes = {
    avisSeleccionat: PropTypes.object,
    peticioMeteorsEnCurs: PropTypes.bool,
    meteors: PropTypes.object,
    dataActual: PropTypes.string,
    peticioDataActualEnCurs: PropTypes.bool,
    onEnterAvis: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        avisSeleccionat: selectorAvisPerId(state),
        peticioMeteorsEnCurs: state.avis.peticioMeteorsEnCurs,
        meteors: state.avis.meteors,
        dataActual: state.dataActual,
        peticioDataActualEnCurs: state.peticioDataActualEnCurs
    };
};

export default errorBoundaryWrapper(connect(mapStateToProps, {onEnterAvis})(Avis));



// WEBPACK FOOTER //
// ./src/components/avis/avis.js